import client from '../../shared/api/client';
import { UserActivity, UserActivitySummary } from '../../shared/types';

interface ActivityListResponse {
  success: boolean;
  data: UserActivity[];
  meta: {
    current_page: number;
    last_page: number;
    per_page: number;
    total: number;
  };
}

export const getUserActivities = async (
  userId: number,
  params?: { category?: string; type?: string; per_page?: number; page?: number }
): Promise<ActivityListResponse> => {
  const response = await client.get<ActivityListResponse>(
    `/user-activities/${userId}`,
    { params }
  );
  return response.data;
};

export const getUserActivitySummary = async (
  userId: number,
  limit: number = 10
): Promise<UserActivitySummary> => {
  const response = await client.get<UserActivitySummary>(
    `/user-activities/${userId}/summary`,
    { params: { limit } }
  );
  return response.data;
};

export const getUserActivity = async (
  userId: number,
  activityId: number
): Promise<{ success: boolean; data: UserActivity }> => {
  const response = await client.get<{ success: boolean; data: UserActivity }>(
    `/user-activities/${userId}/${activityId}`
  );
  return response.data;
};
